import React, { useEffect, useMemo, useState } from 'react';
import './style.scss';
import {
  getIngIdStockNumber,
  GetSeedName,
  GetWellsLabels,
  isNullOrUndefined,
  padZeros,
  GetProteinFormulation,
} from 'utils/Global';
import { LayerIngredient, SeedInfo, WellInfo, WellInfoTemp } from 'business/models/Layer';
import {
  FragmentLayerDTO,
  IFragmentFragmentScreenDTO,
  IProteinFormulationInfoDTO,
  LayerTypeDTO,
  ProteinFormulationInfoDTO,
} from 'business/models/Models';
import { ITabItem } from 'components/tab';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { IStyle } from 'Styles';
import IngredientWellInfo from './IngredientWellInfo';
import IngredientProteinInfo from './IngredientProteinInfo';
import IngredientAdditiveInfo from './IngredientAdditiveInfo';
import { ReactComponent as IngredientsRect } from 'Icons/Sidebar/IngredientsRect.svg';
import { useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import { getIngredient } from 'business/plateviewer/Generate/GenerateCommon';
import {
  useSelectedDropImageParameters,
  useLastSelectedWellNavigationDetails,
} from 'redux/hooks/experiment';

export const getWellInfoHtml = (ingredients) => {
  if (!ingredients) {
    return [];
  }
  const html = [];
  ingredients.map((well, index) => {
    const stockData = well.ingredientStock;
    const highPhIngStockData = well.highPhIngStock;
    if (!well) {
      return;
    }
    html.push(
      <div
        id={`ingredientinfo-getwellinfo-container-index-${index}`}
        key={`ingredient-index-${index}`}
        className="wellinfo"
        style={{ display: 'flex' }}
      >
        <div
          id={`ingredientinfo-getwellinfo-ingredientcolor-index-${index}`}
          className="flex ing-icons  flex-space-between flex-y-center w-1/12"
        >
          <div
            id={`ingredientinfo-getwellinfo-ingredientcolor-${well.ingredientColor}-${index}`}
            style={{
              height: '40px',
              width: '8px',
              marginRight: '10px',
              backgroundColor: well.ingredientColor,
            }}
          ></div>

          <IngredientsRect />
        </div>
        <div
          id={`ingredientinfo-getwellinfo-stock-${index}`}
          className="inline marginLeft10"
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <div id={`ingredientinfo-getwellinfo-stock-${index}-concentration`}>
            <text
              id={`ingredientinfo-getwellinfo-stock-${index}-concentration-value`}
              className="marginRight5"
            >
              {parseFloat(well.concentration.toFixed(3)).toString()}
            </text>
            <text
              id={`ingredientinfo-getwellinfo-stock-${index}-concentration-units`}
              className="marginRight8"
            >
              {well.ingredientStock?.concentrationUnits ?? ''}
            </text>
            <text
              id={`ingredientinfo-getwellinfo-stock-${index}-ingredientname`}
              className="marginRight5"
            >
              {well.ingredientName}
            </text>
            <text>({getIngredient(well.ingredientStock?.ingredientId)?.longName})</text>
            {well.pH && (
              <text
                id={`ingredientinfo-getwellinfo-stock-${index}-ph`}
                className="marginLeft8"
              >
                {well.pH ? 'pH ' + parseFloat(well.pH.toFixed(2)) : ''}
              </text>
            )}
            <text
              id={`ingredientinfo-getwellinfo-stock-${index}-ingredienttypename`}
              className="marginLeft4"
            >
              - {well.ingredientTypeName}
            </text>
          </div>

          {stockData && stockData.isBuffer ? (
            <>
              <div
                id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-wrapper`}
                className="ingredient-card-text ing-card-light"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-data`}>
                  Stock {stockData?.stockConcentration} {stockData?.concentrationUnits},
                  pH {stockData?.stockPh}{' '}
                  {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
                  {'  '}
                  {well?.ingredientStock?.vendorPartNumber}
                </div>
                <div id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-volume`}>
                  {parseFloat((well.ingredientVolume - well.highPHVolume).toFixed(3))}μL
                </div>
              </div>
              {!highPhIngStockData ? null : (
                <div
                  id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-highph-container`}
                  className="ingredient-card-text ing-card-light"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-data`}>
                    Stock {highPhIngStockData.stockConcentration}{' '}
                    {highPhIngStockData.concentrationUnits}, pH{' '}
                    {highPhIngStockData.stockPh}{' '}
                    {getIngIdStockNumber(
                      highPhIngStockData.ingredientId,
                      highPhIngStockData.stockNumber,
                    )}
                    {'  '}
                    {well.ingredientStock.vendorPartNumber}
                  </div>
                  <div
                    id={`ingredientinfo-getwellinfo-stockdata-${index}-isbuffer-highphvolume`}
                  >
                    {well.highPHVolume}μL
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <div
                id={`ingredientinfo-getwellinfo-stockdata-${index}-nonbuffer-wrapper`}
                className="ingredient-card-text ing-card-light"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div id={`ingredientinfo-getwellinfo-stockdata-${index}-nonbuffer-data`}>
                  Stock {stockData?.stockConcentration} {stockData?.concentrationUnits} (
                  {padZeros(stockData?.ingredientId, 4)} -{' '}
                  {padZeros(stockData?.stockNumber, 2)}){'  '}{' '}
                  {well?.ingredientStock?.vendorPartNumber}
                </div>
                <div
                  id={`ingredientinfo-getwellinfo-stockdata-${index}-nonbuffer-ingredientvolume`}
                >
                  {well?.ingredientVolume}μL
                </div>
              </div>
            </>
          )}
        </div>
      </div>,
    );
  });
  return html;
};

export const getProteinIngHTML = (proteinIngredients) => {
  const proteinHTML = [];
  if (!proteinIngredients) {
    return [];
  }
  proteinIngredients.map((protein) => {
    proteinHTML.push(
      <div
        id={`ingredientinfo-getprotein-${protein.name}-container`}
        className="proteininfo ingredientInfoProteinContent"
        style={{ display: 'flex', width: '100%' }}
      >
        <IngredientsRect />
        <div id={`ingredientinfo-getprotein-${protein.name}-wrapper`}>
          <div
            id={`ingredientinfo-getprotein-${protein.name}-name`}
            style={{
              display: 'inline-block',
              marginLeft: 10,
            }}
          >
            {protein.name} - {protein.typeName}
          </div>
          <div
            id={`ingredientinfo-getprotein-${protein.name}-data-wrapper`}
            className="ingredient-card-text ing-card-light"
            style={{ marginLeft: '10px' }}
          >
            Conc:{' '}
            {parseFloat(protein.concentrationmgml).toFixed(3) === undefined ||
            parseFloat(protein.concentrationmgml).toFixed(3) === null ||
            parseFloat(protein.concentrationmgml).toFixed(3) === 'NaN' ? null : (
              <div id={`ingredientinfo-getprotein-${protein.name}-mgml`} className="">
                {parseFloat(protein.concentrationmgml).toFixed(3)} mg/ml
              </div>
            )}
            {parseFloat(protein.concentrationmM).toFixed(3) === undefined ||
            parseFloat(protein.concentrationmM).toFixed(3) === null ||
            parseFloat(protein.concentrationmM).toFixed(3) === 'NaN' ? null : (
              <div id={`ingredientinfo-getprotein-${protein.name}-mm`} className="">
                , {parseFloat(protein.concentrationmM).toFixed(3)} mM
              </div>
            )}
            {parseFloat(protein.moleculerWeight).toFixed(3) === undefined ||
            parseFloat(protein.moleculerWeight).toFixed(3) === null ||
            parseFloat(protein.moleculerWeight).toFixed(3) === 'NaN' ? null : (
              <div id={`ingredientinfo-getprotein-${protein.name}-kda`} className="">
                , {parseFloat(protein.moleculerWeight).toFixed(3)} kDa
              </div>
            )}
          </div>
        </div>
        <br />
      </div>,
    );
  });
  return proteinHTML;
};

export const getStandardIngHtml = (standardIngredients) => {
  const standardIngHtml = [];
  if (!standardIngredients) {
    return [];
  }
  standardIngredients.map((standardIng) => {
    standardIngHtml.push(
      <div
        id={`ingredientinfo-getstandard-${standardIng.ingredientName}-container`}
        className="wellinfo"
        style={{ display: 'flex' }}
      >
        <div
          id={`ingredientinfo-getstandard-${standardIng.ingredientName}-ingredientsrect`}
          className="flex flex-space-between flex-y-center"
        >
          <IngredientsRect />
        </div>
        <div
          id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-wrapper`}
          className="inline marginLeft10"
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <div
            id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-header`}
          >
            {parseFloat(standardIng.concentrationM).toFixed(3)}{' '}
            {standardIng.stockConcentrationUnit} {standardIng.ingredientName} -{' '}
            {standardIng.type}
          </div>
          {standardIng != undefined ? (
            standardIng.type === 'Buffer' ? (
              <div
                id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-type-buffer`}
                className="ingredient-card-text ing-card-light"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div
                  id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-type-buffer-details`}
                >
                  Stock {standardIng.stockConcentration}{' '}
                  {standardIng.stockConcentrationUnit}, pH {standardIng.pH}{' '}
                  {getIngIdStockNumber(standardIng.ingredientID, standardIng.stockNumber)}
                </div>
              </div>
            ) : (
              <div
                id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-type-nonbuffer`}
                className="ingredient-card-text ing-card-light"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div
                  id={`ingredientinfo-getstandard-${standardIng.ingredientName}-data-type-nonbuffer-details`}
                >
                  Stock {standardIng.stockConcentration}{' '}
                  {standardIng.stockConcentrationUnit}{' '}
                  {getIngIdStockNumber(standardIng.ingredientID, standardIng.stockNumber)}
                </div>
              </div>
            )
          ) : null}
        </div>
      </div>,
    );
  });
  return standardIngHtml;
};
export const getDropVolHTMl = (wellInfo) => {
  const dropVolHTMl = [];
  if (!wellInfo) {
    return [];
  }
  dropVolHTMl.push(
    <div
      id="ingredientinfo-getdropvol-wrapper"
      className="content"
      style={{ width: '100%' }}
    >
      <div
        id="ingredientinfo-getdropvol-dropproteinvolume-container"
        className="row paddingmargin0"
      >
        <div
          id="ingredientinfo-getdropvol-dropproteinvolume-title"
          className="col-md-6 paddingmargin0"
        >
          Drop Protein Volume (µL)
        </div>
        <div
          id="ingredientinfo-getdropvol-dropproteinvolume-data"
          className="col-md-6 paddingmargin0"
        >
          {wellInfo.dropProteinVolume} µL
        </div>
      </div>
      <div className="row paddingmargin0">
        <div
          id="ingredientinfo-getdropvol-dropwellvolume-title"
          className="col-md-6 paddingmargin0"
        >
          Drop Well Volume (µL)
        </div>
        <div
          id="ingredientinfo-getdropvol-dropwellvolume-data"
          className="col-md-6 paddingmargin0"
        >
          {wellInfo.dropWellVolume} µL
        </div>
      </div>
      <br />
    </div>,
  );
  return dropVolHTMl;
};
const getAdditivesHTML = (wellinfo) => {
  const additivesHTML = [];
  if (wellinfo.additives !== undefined && wellinfo.additives !== null) {
    wellinfo.additives.map((additive) => {
      const stockData = additive.ingredientStock;
      additivesHTML.push(
        <>
          <div
            id={`ingredientinfo-getadditives-${additive.ingredientName}-dropnumber`}
            style={{ display: 'flex', justifyContent: 'space-between', width: '50%' }}
          >
            <div
              id={`ingredientinfo-getadditives-${additive.ingredientName}-dropnumber-title`}
            >
              Drop
            </div>
            <div
              id={`ingredientinfo-getadditives-${additive.ingredientName}-dropnumber-value`}
            >
              Drop {additive.dropNumber}
            </div>
          </div>
          <div
            id={`ingredientinfo-getadditives-${additive.ingredientName}-wrapper`}
            className="wellinfo"
            style={{ display: 'flex' }}
          >
            <div
              id={`ingredientinfo-getadditives-${additive.ingredientName}-ingredientsrect`}
              className="flex  flex-space-between flex-y-center"
            >
              <IngredientsRect />
            </div>
            <div
              id={`ingredientinfo-getadditives-${additive.ingredientName}-container`}
              className="inline marginLeft10"
              style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
            >
              <div id={`ingredientinfo-getadditives-${additive.ingredientName}-header`}>
                {parseFloat(additive.concentration).toFixed(3)}{' '}
                {additive.concentrationUnit} {additive.ingredientName} -{' '}
                {additive.ingredientTypeName}
              </div>
              {stockData != undefined ? (
                stockData.isBuffer ? (
                  <div
                    id={`ingredientinfo-getadditives-${additive.ingredientName}-buffer-wrapper`}
                    className="ingredient-card-text ing-card-light"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div
                      id={`ingredientinfo-getadditives-${additive.ingredientName}-buffer-data`}
                    >
                      Stock {stockData.stockConcentration} {stockData.concentrationUnits},
                      pH {stockData.stockPh}{' '}
                      {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
                    </div>
                    <div
                      id={`ingredientinfo-getadditives-${additive.ingredientName}-buffer-volume`}
                    >
                      {parseFloat(additive.ingredientVolume).toFixed(3) + 'μL'}
                    </div>
                  </div>
                ) : (
                  <div
                    id={`ingredientinfo-getadditives-${additive.ingredientName}-nonbuffer-wrapper`}
                    className="ingredient-card-text ing-card-light"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div
                      id={`ingredientinfo-getadditives-${additive.ingredientName}-nonbuffer-data`}
                    >
                      Stock {stockData.stockConcentration} {stockData.concentrationUnits}{' '}
                      (
                      {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
                    </div>
                    <div
                      id={`ingredientinfo-getadditives-${additive.ingredientName}-nonbuffer-volume`}
                    >
                      {parseFloat(additive.ingredientVolume).toFixed(3) + 'μL'}
                    </div>
                  </div>
                )
              ) : null}
            </div>
          </div>
        </>,
      );
    });
  }
  return additivesHTML;
};

export default function IngredientInfo() {
  const [wellInfoHTML, setWellInfoHTML] = useState([]);
  const [proteinInfoHTML, setProteinInfoHTML] = useState([]);
  const [proteinStandardIngredientInfoHTML, setproteinStandardIngredientInfoHTML] =
    useState([]);
  const [additivesInfoHTML, setAdditivesInfoHTML] = useState([]);
  const [proteinInfo, setProteinInfo] = useState<ProteinFormulationInfoDTO>();

  const [dropVol, setDropVolume] = useState([]);
  const [seedInfo, setSeedInfo] = useState<SeedInfo>(undefined);
  const [fragmentFragentScreens, setFragmentFragentScreens] =
    useState<IFragmentFragmentScreenDTO[]>(null);
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const exp = useRMSelector(selectExp);
  const { wellNum, plateID } = wellNavigationDetails || {};
  const { dropNumber } = selectedDropImageParameters || {};

  const { well, proteinFormulation } = useMemo(() => {
    if (!exp.plateDto) {
      return { well: null, proteinFormulation: null, plateName: '' };
    }
    let plate = exp.plateDto.find((pl) => pl.plateId === plateID);
    if (plate === null || plate === undefined) {
      plate = exp.plateDto[0];
    }
    const well = !isNullOrUndefined(plate.ingredients)
      ? plate.ingredients.wellList[wellNum - 1]
      : null;
    const proteinFormulation = !isNullOrUndefined(plate.ingredients)
      ? plate.ingredients.proteinFormulation
      : null;
    return { well, proteinFormulation, plateName: plate.plateBarName };
  }, [exp.plateDto, wellNum, plateID]);

  const wellLable = useMemo(() => {
    const labels = GetWellsLabels();
    return labels[wellNum ? wellNum - 1 : 0]?.name || '';
  }, [GetWellsLabels, wellNum]);

  function setWellInfoFromWellLayerList() {
    const wellInfoTemp: WellInfoTemp = {
      additives: [],
      ingredients: [],
      proteinFormulationIngredients: [],
      proteinFormulationStandardIngredients: [],
      proteinInfo: {} as IProteinFormulationInfoDTO,
      seedInfo: {} as SeedInfo,
      wellInfo: {} as WellInfo,
      dropFragmentInfo: [],
    };

    const welllayerIng = [];
    wellInfoTemp.proteinFormulationIngredients = [];
    wellInfoTemp.proteinFormulationStandardIngredients = [];

    wellInfoTemp.additives = [];
    if (well.dropList) {
      well.dropList.map((drop) => {
        if (drop.dropNumber == selectedDropImageParameters?.dropNumber) {
          if (drop.proteinFormulationID !== null) {
            // Try to get protein info from experiment state first
            if (
              proteinFormulation &&
              proteinFormulation[drop.proteinFormulationID] !== undefined
            ) {
              wellInfoTemp.proteinInfo = new ProteinFormulationInfoDTO();
              wellInfoTemp.proteinInfo =
                proteinFormulation[drop.proteinFormulationID].proteinInfo;
              wellInfoTemp.proteinInfo = {
                ...wellInfoTemp.proteinInfo,
                dropNumber: drop.dropNumber,
                dropProteinVolume: drop.dropProteinVolume,
                dropWellVolume: drop.dropWellVolume,
              } as any;

              wellInfoTemp.proteinFormulationIngredients = [
                ...wellInfoTemp.proteinFormulationIngredients,
                ...proteinFormulation[drop.proteinFormulationID].ingredients,
              ];

              wellInfoTemp.proteinFormulationStandardIngredients = [
                ...wellInfoTemp.proteinFormulationStandardIngredients,
                ...proteinFormulation[drop.proteinFormulationID].standardIngredients,
              ];
            } else {
              // Fallback: Get protein info from global protein formulation list for unsaved experiments
              const globalPF = GetProteinFormulation(drop.proteinFormulationID);
              if (globalPF) {
                wellInfoTemp.proteinInfo = new ProteinFormulationInfoDTO();
                wellInfoTemp.proteinInfo = {
                  name: globalPF.pfName || '',
                  proteinLotId: globalPF.proteinLotId || '',
                  volume: globalPF.volume || 0,
                  storageTemp: globalPF.storageTemp || '',
                  pclass: globalPF.Class || '',
                  extCoefficient: globalPF.extCoefficient || '',
                  datePrepared: globalPF.datePrepared
                    ? new Date(globalPF.datePrepared)
                    : null,
                  dropNumber: drop.dropNumber,
                  dropProteinVolume: drop.dropProteinVolume,
                  dropWellVolume: drop.dropWellVolume,
                } as any;

                // Map ingredients from global PF format to expected format
                if (globalPF.pfIng && globalPF.pfIng.length > 0) {
                  wellInfoTemp.proteinFormulationIngredients = globalPF.pfIng.map(
                    (ing) => ({
                      name: ing.name || '',
                      typeName: ing.typeName || '',
                      concentrationmgml: ing.concentrationmgml || 0,
                      concentrationmM: ing.concentrationmM || 0,
                      moleculerWeight: ing.moleculerWeight || 0,
                      Lot: ing.Lot || '',
                      ID: ing.ID || 0,
                    }),
                  );
                }

                // Map standard ingredients from global PF format to expected format
                if (globalPF.pfStIng && globalPF.pfStIng.length > 0) {
                  wellInfoTemp.proteinFormulationStandardIngredients =
                    globalPF.pfStIng.map((ing) => ({
                      ingredientName: ing.ingredientName || '',
                      concentrationM: ing.concentrationM || 0,
                      pH: ing.pH || 0,
                      stockConcentration: ing.stockConcentration || 0,
                      stockConcentrationUnit: ing.stockConcentrationUnit || '',
                      type: ing.type || '',
                      ingredientID: ing.ingredientID || 0,
                      stockNumber: ing.stockNumber || 0,
                    }));
                }
              }
            }
          }

          if (drop.seedID !== null) {
            const seedInfo = new SeedInfo();
            seedInfo.seedName = GetSeedName(drop.seedID);
            setSeedInfo(seedInfo);
          }

          if (
            wellInfoTemp?.wellInfo?.dropProteinVolume === undefined ||
            wellInfoTemp?.wellInfo?.dropProteinVolume === null
          ) {
            wellInfoTemp.wellInfo.dropProteinVolume = 0;
          }
          wellInfoTemp.wellInfo.dropProteinVolume += drop.dropProteinVolume;

          if (
            wellInfoTemp?.wellInfo?.dropWellVolume === undefined ||
            wellInfoTemp?.wellInfo?.dropWellVolume === null
          ) {
            wellInfoTemp.wellInfo.dropWellVolume = 0;
          }
          wellInfoTemp.wellInfo.dropWellVolume += drop.dropWellVolume;

          drop.dropLayerList.map((dropLayer) => {
            !isNullOrUndefined(dropLayer.dropLayerIngredientList) &&
              dropLayer.dropLayerIngredientList.map((dropIngredient) => {
                const layerIngredient: LayerIngredient = {
                  ingredientColor: dropIngredient.hexColor,
                  concentration: dropIngredient.concentration,
                  concentrationUnit: dropIngredient.ingredientStock.concentrationUnits,
                  ingredientVolume: dropIngredient.volume,
                  ingredientTypeName: dropIngredient.ingredientTypeName,
                  ingredientStock: dropIngredient.ingredientStock,
                  dropNumber: drop.dropNumber,
                  ingredientName: dropIngredient.ingredientStockIngredient.longName,
                };

                wellInfoTemp.additives.push({
                  ...layerIngredient,
                  stockConcentration: dropIngredient.ingredientStock.stockConcentration,
                  volume: dropIngredient.volume,
                });
              });

            const layer = exp.layers.find((lyr) => lyr.id === dropLayer.layerId);
            if (layer && layer.type === LayerTypeDTO.Fragment) {
              const fragmentLayerDetail = layer.layerDetail as FragmentLayerDTO;
              const fragmentScreenId = fragmentLayerDetail.fragmentScreenId;

              // Try to get fragment data from dropLayerFragmentList first (for saved experiments)
              if (
                dropLayer.dropLayerFragmentList &&
                dropLayer.dropLayerFragmentList.length > 0
              ) {
                dropLayer.dropLayerFragmentList.map((dropLayerFragment) => {
                  wellInfoTemp.dropFragmentInfo.push({
                    fragmentId: dropLayerFragment.fragmentId,
                    fragmentScreenId: fragmentScreenId,
                  });
                });
              } else if (
                fragmentLayerDetail.fragmentScreen &&
                fragmentLayerDetail.fragmentScreen.fragmentFragmentScreen &&
                fragmentLayerDetail.fragmentScreen.fragmentFragmentScreen.length > 0
              ) {
                // Fallback: Get fragment data from layer's fragmentScreen for unsaved experiments
                fragmentLayerDetail.fragmentScreen.fragmentFragmentScreen.map(
                  (fragmentFragmentScreen) => {
                    wellInfoTemp.dropFragmentInfo.push({
                      fragmentId: fragmentFragmentScreen.fragmentId,
                      fragmentScreenId: fragmentScreenId,
                    });
                  },
                );
              }
            }
          });
        }
      });
    }
    well.wellLayerList.map((wellLayer) => {
      wellLayer.wellLayerIngredientList.map((ingredient) => {
        const layerIngredient: LayerIngredient = new LayerIngredient();
        layerIngredient.ingredientColor = ingredient.hexColor;
        layerIngredient.concentration = ingredient.concentration;
        layerIngredient.concentrationUnit = ingredient.ingredientStock.concentrationUnits;
        layerIngredient.ingredientName = ingredient.ingredientStockIngredient.shortName;
        layerIngredient.ingredientTypeName = ingredient.ingredientTypeName;
        layerIngredient.ingredientStock = ingredient.ingredientStock;
        layerIngredient.ingredientVolume = ingredient.volume;
        layerIngredient.highPhIngStock = ingredient.highPhIngStock;
        layerIngredient.highPHVolume = ingredient.highPHVolume;
        layerIngredient.pH = ingredient?.pH;

        welllayerIng.push(layerIngredient);
      });
    });
    wellInfoTemp.ingredients = welllayerIng;

    return wellInfoTemp;
  }

  useEffect(() => {
    let wellinfo = null;
    if (isNullOrUndefined(well)) {
      return;
    }

    wellinfo = setWellInfoFromWellLayerList();
    //selected drop number assigned if the proteinInfo object is null or {}
    if (!wellinfo.proteinInfo.dropNumber) {
      wellinfo.proteinInfo.dropNumber = dropNumber;
    }

    const html = getWellInfoHtml(wellinfo?.ingredients);
    const proteinIngredientsHTML = getProteinIngHTML(
      wellinfo.proteinFormulationIngredients,
    );
    const dropVolHTMl = getDropVolHTMl(wellinfo?.wellInfo);
    const standardIngHtml = getStandardIngHtml(
      wellinfo.proteinFormulationStandardIngredients,
    );
    const additivesHTML = getAdditivesHTML(wellinfo);

    setWellInfoHTML(html);
    setProteinInfoHTML(proteinIngredientsHTML);
    setDropVolume(dropVolHTMl);
    setproteinStandardIngredientInfoHTML(standardIngHtml);
    setAdditivesInfoHTML(additivesHTML);
    setProteinInfo(wellinfo.proteinInfo);
    setFragmentFragentScreens(wellinfo.dropFragmentInfo);
    /**RFR: Need to narrow down the dependencies*/
  }, [wellLable, plateID, well, proteinFormulation, wellNum, dropNumber]);

  const isScreenRoute = window.location.pathname.includes('/screen');

  const tabComponents: ITabItem[] = [
    {
      title: 'Well',
      eventKey: 'well',
      content: (
        <IngredientWellInfo
          wellName={wellLable}
          dropVol={dropVol}
          wellInfoHTML={wellInfoHTML}
          wellVolume={well?.wellVolume}
          wellWaterVolume={well?.wellWaterVolume}
        />
      ),
    },
    {
      title: 'Protein',
      eventKey: 'protein',
      content: (
        <IngredientProteinInfo
          isScreenRoute={isScreenRoute}
          proteinInfo={proteinInfo}
          seedInfo={seedInfo}
          proteinIngredientsHTML={proteinInfoHTML}
          standardIngredientHTML={proteinStandardIngredientInfoHTML}
          well={well}
          fragmentIds={fragmentFragentScreens}
        />
      ),
    },
    {
      title: 'Additives',
      eventKey: 'additives',
      content: <IngredientAdditiveInfo additivesInfoHTML={additivesInfoHTML} />,
    },
  ];

  const styles: IStyle = {
    container: {
      height: '100%',
    },
  };

  return (
    <>
      <div
        id="ingredientinfo-main-container"
        className="container-fluid p-0"
        style={styles.container}
      >
        <RMTabs
          tabItems={tabComponents}
          defaultActiveKey={'well'}
          id={'IngredientInfoTab'}
        />
      </div>
    </>
  );
}
